// src/components/help-support/FAQ.tsx

import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SearchInput } from "../inputs";
import Accordion from "../shared/Accordion";
import FAQItem from "../../interfaces/FAQ";
import axiosInstance from "../../config/axios"; // Update with correct path
import faqImage from '../../assets/images/help-center3.png';
import { fetchFAQs } from "../../store/reducers/faqsSlice";
import { AppDispatch, RootState } from "../../store";

const FAQ = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { items, isLoading } = useSelector((state: RootState) => state.faqs);
  const [displayedFaqs, setDisplayedFaqs] = useState<FAQItem[]>([]);

  useEffect(() => {
    dispatch(fetchFAQs());
  }, []);

  // useEffect(() => {
  //   setDisplayedFaqs(items);
  // }, [items]);
  const updatedItems = useMemo(() => {
    return items.filter(
      (faq) => faq.type === "General"
    );
  }, [items]);

  useEffect(() => {
    console.log("Fetched FAQs: ", items);
    const generalFaqs = items.filter(
      (faq) => faq.type === "General"
    );
    setDisplayedFaqs(generalFaqs);
  }, [items]);

  // const handleSearch = (text: string) => {
  //   if (text.length === 0) {
  //     setDisplayedFaqs(items);
  //     return;
  //   }
  //   const filtered = items.filter((faq) =>
  //     faq.question.toLowerCase().includes(text.toLowerCase())
  //   );
  //   setDisplayedFaqs(filtered);
  // };

  const handleSearch = (text: string) => {
    const generalFaqs = items.filter(
      (faq) => faq.type === "General"
    );

    if (text.length === 0) {
      setDisplayedFaqs(generalFaqs);
      return;
    }

    const filtered = generalFaqs.filter((faq) =>
      faq.question.toLowerCase().includes(text.toLowerCase())
    );

    setDisplayedFaqs(filtered);
  };

  return (
    <>
      <div className="flex h-[140px] justify-between p-4 items-center rounded-xl bg-app-blue text-white mobile:m-2">
        <div className="text-left">
          <span className="font-bold font-lato text-[28px] bold text-app-yellow mt-1">
            You have a question? We have the answer!
          </span>
          <p className="text-white font-light text-sm">
            FAQs will answer your questions about Viliyo and guide
            <br />
            you through various features and configurations.
          </p>
        </div>
        <img
          alt="Welcome"
          src={faqImage}
          width={120}
          height={120}
        />
      </div>
      <div className="overflow-y-auto h-[calc(100vh-4rem)]">
        <div className="w-full py-4">
          <div className="mobile:mr-4 float-right tablet:mr-4 border-2 rounded-full mr-4 mb-2">
            <SearchInput onChange={handleSearch} placeholder="Search" />
          </div>
        </div>

        <div className="m-2">
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            updatedItems.map((faq, index) => (
              <Accordion
                key={index}
                index={index + 1}
                title={faq.question}
                content={faq.answer}
              />
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default FAQ;
